export const API_URL = {
  MASTER_DATA: {
    GET_COMPANY: "/api/v1/company",
    GET_SECTOR: "/api/v1/sector",
    GET_AREA: "/api/v1/area",
    GET_STORE: "/api/v1/store",
    GET_PROCESSING_CENTER: "/api/v1/processingcenter",
  },
  USER: {
    SEARCH: "/api/v1/user/search",
    DETAIL: "/api/v1/user",
  },
  SEARCH_SALE_STATUS_CHECK: "/sales-status",
  GET_SALE_STATUS_IMAGE_DETAIL: "/sales-status/images",
  COMMENT: "/comment",
  SEARCH_CAMERA_STATUS: "/camera",
  REGIS_CAMERA: "/camera/batch",
  EDIT_CAMERA: "/camera",
  DETAIL_CAMERA: "/camera",
  SEARCH_CGI: "/cgi/cameraInfo",
  CAMERA_CAPTURE: "/CameraCapture",

  IMPORT_COMPANY: "/api/v1/company/import",
  IMPORT_SECTOR: "/api/v1/sector/import",
  IMPORT_PROCESSING_CENTER: "/api/v1/processingcenter/import",
  IMPORT_AREA: "/api/v1/area/import",
  IMPORT_USER: "/api/v1/user/import",
  IMPORT_STORE: "/api/v1/store/import",
  IMPORT_CAMERA: "/camera/import",
  STORE_MASTER: {
    SEARCH: "/api/v1/store/search",
    COMMON: "/api/v1/store",
  },
  DISTRICT: {
    SEARCH: "/api/v1/sector/search",
    UPDATE_DISTRICT: "/api/v1/sector/:id",
    DELETE_DISTRICT: "/api/v1/sector/:id",
  },

  SEARCH_COMPANY: "/api/v1/company/search",
  REGISTRATION_COMPANY: "/api/v1/company/create",
  DELETE_COMPANY: "/api/v1/company/delete",
  UPDATE_COMPANY: "/api/v1/company/update",
  CHECK_EXIST_COMPANY: "/api/v1/company/check-code",
};
